import { render, staticRenderFns } from "./RequirementServices.vue?vue&type=template&id=51f687ec"
import script from "./RequirementServices.vue?vue&type=script&lang=js"
export * from "./RequirementServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports